<template>
  <div class="technologies">
    <div class="glitch" data-text="MY EXPERTISE">MY EXPERTISE</div>
    <div class="chart-box">
      <div class="table">
        <div class="env">
          <div class="title">Frontend</div>
          <div class="description">
            <div style="--line-color:#f3bb42">
            </div>
            <span>
              Lover of UI/UX.<br>
              Over 2 years of development expirience in HTML, CSS, JS, and Javascript frameworks Vue3 and React.
            </span>
          </div>
          <div class="badges">
            <img src="../assets/programming_languages/js.png"/>
            <img src="../assets/programming_languages/bootstrap.png"/>
            <img src="../assets/programming_languages/react.png"/>
            <img src="../assets/programming_languages/webgl.png"/>
            <img src="../assets/programming_languages/html.png"/>
            <img src="../assets/programming_languages/vue.png"/>
          </div>
        </div>
        <div class="env">
          <div class="title">Backend</div>
          <div class="description">
            <div  style="--line-color:#87a18a">
            </div>
            <span>
              Expirienced in everything concerning the functional and OOP: Python, NodeJs, C++, and Java. <br>Excellent ability to manage relational and non-relational databases
            </span></div>
          <div class="badges">
            <img src="../assets/programming_languages/python.png"/>
            <img src="../assets/programming_languages/java.png"/>
            <img src="../assets/programming_languages/lambda.png" style="filter:contrast(0)"/>
            <img src="../assets/programming_languages/haskell.png"/>
            <img src="../assets/programming_languages/c.png"/>
            <img src="../assets/programming_languages/c++_logo.png"/>
            <img src="../assets/programming_languages/Dart-logo.png"/>
            <img src="../assets/programming_languages/Erlang_logo.svg.png" style="filter:contrast(0)"/>
            <img src="../assets/programming_languages/node.png"/>
            <img src="../assets/programming_languages/Solidity-Logo.wine.png" style="filter:contrast(0)"/>
            <img src="../assets/programming_languages/VB.NET_Logo.svg.png"/>
          </div>
        </div>
        <div class="env">
          <div class="title">Infrastructure</div>
          <div class="description">
            <div style="--line-color:#fcefc1">
            </div>
            <span>
              IaaS-style infrastructure practitioner with Terraform. Specialized in GCP and AWS environments.
            </span></div>
            <div class="badges">

              <img src="../assets/programming_languages/terraform-icon.svg"/>
              <img src="../assets/programming_languages/amazon.png"/>
              <img src="../assets/programming_languages/gcp.png"/>
            </div>
        </div>
      </div>
    </div>
    <Carousel />
  </div>
</template>

<script>
import Carousel from "@/components/Carousel.vue";

export default {
  name: "TechnologiesView",
  data() {
    return {
      show: false,
    };
  },
  components: { Carousel },
};
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
  display: flex;
  height: 68vh;
  gap: 10px;
  padding: 30px 0;
  > .env {
    border: 1px solid #ffffff;
    width: 100%;
    display: flex;
    flex-direction: column;
    .title {
      position: relative;
      width: 100%;
      background: #ffffff;
      height: 15%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: black;
      font-size: calc(100vw / 60);
      text-align: center;
    }
    .description {
      height: 35%;
      padding: calc(100vw / 70);
      font-size: calc(100vw/120);
      overflow: hidden;
      font-family: "Courier New", Courier, monospace;
      display: flex;      justify-content: center;
      align-items: center;
      > div {
        width: 10%;
        height: 80%;
        position: relative;
        border-left: 1px solid var(--line-color);
        &::before {
          content:'<h3>';
            font-family: 'La Belle Aurore', cursive;
    color: #848488;
            position:absolute;
            top: calc(-100vh/30);
            left: calc(-100vw/100);
        }
        &::after {
          font-family: 'La Belle Aurore', cursive;
    color: #848488;
          content:'</h3>';
          bottom: calc(-100vh/30);
          position:absolute;
          left: calc(-100vw/90);
        }
      }
      > span {
        width: 80%;
      }
    }
    .badges {
      height: 50%;
      border-top: 1px solid white;
    }
  }
}
.technologies {
  overflow: hidden;
  position: relative;
  padding: 20px calc(100vw/10);
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  &__title {
    position: absolute;
    text-align: left;
    top: 0;
    left: 0;
  }
}
.glitch {
  color: white;
  font-size: clamp(30px, 3vw, 70px);
  position: relative;
  width: 100%;
  margin: 0 0 !important;
  &.list {
    font-size: 35px;
    font-family: "Courier New", Courier, monospace;
  }
}
@keyframes noise-anim {
  $steps: 20;
  @for $i from 0 through $steps {
    #{percentage($i*(1/$steps))} {
      clip: rect(random(100) + px, 9999px, random(100) + px, 0);
    }
  }
}
.glitch:after {
  content: attr(data-text);
  position: absolute;
  left: 2px;
  text-shadow: -1px 0 red;
  top: 0;
  color: white;
  background: black;
  overflow: hidden;
  clip: rect(0, 900px, 0, 0);
  animation: noise-anim 2s infinite linear alternate-reverse;
}

@keyframes noise-anim-2 {
  $steps: 20;
  @for $i from 0 through $steps {
    #{percentage($i*(1/$steps))} {
      clip: rect(random(100) + px, 9999px, random(100) + px, 0);
    }
  }
}
.glitch:before {
  content: attr(data-text);
  position: absolute;
  left: -2px;
  text-shadow: 1px 0 blue;
  top: 0;
  color: white;
  background: black;
  overflow: hidden;
  clip: rect(0, 900px, 0, 0);
  animation: noise-anim-2 3s infinite linear alternate-reverse;
}
.chart-box {
  height: 100%;
  width: 100%;
  display: flex;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  background: rgb(0, 0, 0);
  > img {
    object-fit: contain;
    height: auto;
    width: auto;
    padding: calc(100vw/400);
    margin: auto;
    max-width: 7vw;
    max-height: 7vh; 
  }
}
@media only screen and (max-width: 768px) {
  .table {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: auto;
  gap: 10px;
  padding: 30px 0;
  > .env {
    border: 1px solid #ffffff;
    width: 100%;
    display: flex;
    flex-direction: column;
    .title {
      position: relative;
      width: 100%;
      background: #ffffff;
      height: 15%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: black;
      font-size: calc(100vw / 40);
      text-align: center;
    }
    .description {
      height: 50%;
      padding: calc(100vw / 70);
      font-size: calc(100vw/50);
      overflow: hidden;
      font-family: "Courier New", Courier, monospace;
      display: flex;      justify-content: center;
      align-items: center;
      > div {
        width: 10%;
        height: 80%;
        position: relative;
        border-left: 1px solid var(--line-color);
        &::before {
          content:'<h3>';
            font-family: 'La Belle Aurore', cursive;
    color: #848488;
            position:absolute;
            top: calc(-100vh/80);
            left: calc(-100vw/134);
        }
        &::after {
          font-family: 'La Belle Aurore', cursive;
    color: #848488;
          content:'</h3>';
          bottom: calc(-100vh/60);
          position:absolute;
          left: calc(-100vw/90);
        }
      }
      > span {
        width: 80%;
      }
    }
    .badges {
      height: 40%;
      border-top: 1px solid white;
    }
  }
}
.technologies {
  overflow: hidden;
  position: relative;
  padding: 20px calc(100vw/10);
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  &__title {
    position: absolute;
    text-align: left;
    top: 0;
    left: 0;
  }
}
.chart-box {
  height: 100%;
  width: 100%;
  display: flex;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  background: rgb(0, 0, 0);
  > img {
    object-fit: contain;
    height: auto;
    width: auto;
    padding: calc(100vw/100);
    margin: auto;
    max-width: 7vw;
    max-height: 4vh; 
  }
}
}
</style>
